export enum PERSONALIZATION_UX_BRAND_VARIATIONS {
  Enabled = 'PersonalizationUXBrandEnabled',
  Control = 'PersonalizationUXBrandControl',
}

export const PERSONALIZATION_UX_BRAND_EXPERIMENT_NAME = 'personalization_gal6_brand_kit'

export const PersonalizationBoostingExperimentFlags = {
  boost_exploration: '0.5',
  boost_coefficient: '0',
  boost_limit_part: '0.5',
} as Gallery.Models.Url.ASPExperimentFlags

export const IMAGE_PLACEHOLDER_BOOST_KEY = 'ImagePlaceholder'

export const IMAGE_PLACEHOLDER_BOOST_WEIGHT = 1
